/*    FILE TO HANDLE FLOATING VUE DEFAULTS
 *    CONFIG ALLOWS GLOBAL DEFAULTS, TOOLTIP DEFAULTS AND POPOVER DEFAULTS.
 *    GLOBAL ARE APPLIED TO ALL. TOOLTIP AND POPOVER CAN OVERRIDE GLOBAL FOR ITS OWN COMPONENTS.
 */

// GLOBAL DEFAULTS
const FV_DEFAULTS = { placement: 'top', distance: 10 }

export { FV_DEFAULTS }
